var map = {
	"./de.json": 62140,
	"./en.json": 25576,
	"./es.json": 79087,
	"./fr.json": 58523,
	"./it.json": 86598,
	"./nl.json": 58001,
	"./pt.json": 27627,
	"./vi.json": 45874
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 3 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | App_1yozx5y-i18n */ 365).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 62542;
module.exports = webpackAsyncContext;